import React from 'react';
import Icon$1 from '@amzn/awsui-components-react/polaris/icon';
import { renderReact, parseParams } from '../utils/markdown.plugin.utils.js';
import { iconList } from '../constants/iconList.js';

const renderIcon = (tokens, idx, options, env) => {
  return renderReact(_ref => {
    let {
      content
    } = _ref;
    const {
      meta: {
        size,
        iconName,
        variant
      }
    } = content;
    return /*#__PURE__*/React.createElement(Icon$1, {
      className: "bork-icon",
      size: size,
      name: iconName,
      variant: variant
    });
  })({
    content: tokens[idx],
    origRender: '',
    env,
    tokens
  });
};
const BASE_MARKER = '::';
const OPEN_MARKER_STR = "".concat(BASE_MARKER, "icon");
const OPEN_MARKER_LEN = OPEN_MARKER_STR.length;
const END_MARKER = '::';
const END_MARKER_LEN = END_MARKER.length;
const coreRule = (state, silent) => {
  let found,
    content,
    token,
    max = state.posMax,
    start = state.pos;

  // early exit conditions
  if (silent) return false;
  // check starts with ::icon
  if (!state.src.startsWith(OPEN_MARKER_STR, start)) return false;
  // no empty render ::icon::
  if (start + OPEN_MARKER_LEN + END_MARKER_LEN >= max) return false;
  state.pos = start + OPEN_MARKER_LEN;

  // iterate through chars to find close markers ::
  while (state.pos < max) {
    if (state.src.startsWith(END_MARKER, state.pos)) {
      found = true;
      break;
    }
    state.md.inline.skipToken(state);
  }

  // no render if closing markers not found ::icon
  if (!found) {
    state.pos = start;
    return false;
  }

  // found! grab content between open and close markers
  content = state.src.slice(start + OPEN_MARKER_LEN, state.pos);
  // parse passed icon parameters from content
  const passedParameters = parseParams(content);

  // Don't render icon if icon name is invalid
  if (!iconList.has(passedParameters.name)) {
    // Reset position in state for next rendering rule to run
    state.pos = start;
    state.posMax = max;
    return false;
  }

  // Push icon token into token stream
  token = state.push('icon', '', 0);
  token.meta = {
    iconName: passedParameters.name,
    size: passedParameters.size || 'inherit',
    variant: passedParameters.variant || 'normal'
  };

  // icon token has been pushed into stream
  // set position to after icon END_MARKER and set max position back to max
  state.pos += END_MARKER_LEN;
  state.posMax = max;
  return true;
};
const iconPlugin = md => {
  md.inline.ruler.after('emphasis', 'icon', coreRule);
  md.renderer.rules.icon = renderIcon;
};
var Icon = (() => ({
  plugin: iconPlugin
}));

export { Icon as default };
